import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import {AuthService} from "./auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private auth = inject(AuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.auth.jwt() != null) {
      const req = request.clone({
        headers: request.headers.set('Authorization', `bearer ${this.auth.jwt()}`)
      });
      return next.handle(req);
    } else {
      return next.handle(request);
    }
  }
}
